import React from "react";
import {connect} from "react-redux";
import ContratoForm from "./contrato.frm";

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		pasoSiguiente: () => {
			dispatch({ "type": "CONTRATOS_PASO_SIGUIENTE" });
			dispatch({ "type": "CONTRATOS_MEDIOS_ELECTRONICOS", "mediosElectronicos": true });
		},
		pasoError: () => {
			dispatch({ "type": "CONTRATOS_PASO_ERROR" });
		}
	};
};

class Contrato extends React.Component{

	submit = (data) => {
		if(data.acepto == true) {
			this.props.pasoSiguiente();
		} else {
			this.props.pasoError();
		}
	}

	render() {
		return <ContratoForm onSubmit={this.submit} />;
	}

}

export default connect(null, mapDispatch)(Contrato);


// WEBPACK FOOTER //
// ./src/contrato/contrato.cmpt.js